export default "__VITE_ASSET__2786ae83__"